<script setup>
import { checkAccess } from '@/core/helpers/auth.helper';
import { Scope, ScopeType } from '@/core/models/allowed-scopes.interface';

// #region redirect
const router = useRouter();

onBeforeMount(() => {
   const HAS_ACCESS = checkAccess(ScopeType.Tenants, [Scope.View, Scope.Update]);
   if (!HAS_ACCESS) router.push({ name: 'ErrorPage' });
});
// #endregion

// #region breadcrumbs
const { t } = useI18n();
const { commit } = useStore();

watchEffect(() => {
   commit('header/SET_BREADCRUMBS', [{ to: '/companies', content: t('companies.companies', 2) }]);
});
// #endregion
</script>

<template>
   <RouterView v-if="checkAccess(ScopeType.Tenants, [Scope.View, Scope.Update])" />
   <div v-else></div>
</template>
